<script>
  import {dd} from 'systems/imports'

  export default {
    created(){
    },
    mounted(){
      this.$emit('InitloggedIn')
    },
    methods:{
        abcd(){
        }
    },
  };
</script>



// WEBPACK FOOTER //
// LoggedInPageBase.vue?74b89dbc